export const normalizePusherMessageData = (messageData) => {
  if (messageData?.messageGuid !== undefined && messageData?.data !== undefined) {
    return messageData.data;
  }
  return messageData;
};
